import React, { cloneElement, isValidElement, useEffect, useRef, useState } from 'react';
import IconTint from 'react-icon-tint';
import downIcon from '../assets/icons/ic_arrowdown.svg';

const ItemComboBox = ({ id, value, onChange, items = [], placeholder = 'Item description', className = '', children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const uniqueItems = [...new Set(items.map(item => item.trim()).filter(Boolean))];
  const hasItems = uniqueItems.length > 0;
  const selectedItems = value.split(',').map(item => item.trim()).filter(Boolean);

  useEffect(() => {
    const onMouseDown = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', onMouseDown);
    return () => document.removeEventListener('mousedown', onMouseDown);
  }, []);

  const onToggleItem = (item) => {
    const isSelected = selectedItems.includes(item);
    const nextItems = isSelected
      ? selectedItems.filter(selectedItem => selectedItem !== item)
      : [...selectedItems, item];

    onChange(nextItems.join(', '));
  };

  return (
    <div ref={containerRef} className='relative w-full mt-1'>
      <input
        id={id}
        className={`${className} ${hasItems ? 'pr-20' : ''}`}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />

      {hasItems && (
        <button
          type='button'
          onClick={() => setIsOpen(current => !current)}
          className='absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-[#3C5BD2] hover:bg-opacity-10'
          aria-label='Show default items'
        >
          <IconTint src={downIcon} className={`h-3 transition-transform ${isOpen ? 'rotate-180' : ''}`} color='#3C5BD2' />
        </button>
      )}

      {isValidElement(children)
        ? cloneElement(children, {
          onBeforeStart: () => {
            setIsOpen(false);
            children.props.onBeforeStart?.();
          },
        })
        : children}

      {hasItems && isOpen && (
        <div className='absolute left-0 right-0 z-20 mt-1 py-2 bg-[#e1e6fd] rounded-md shadow-xl max-h-48 overflow-auto'>
          {uniqueItems.map(item => (
            <label
              key={item}
              className='flex w-full items-center gap-2 px-4 py-1.5 text-md font-light cursor-pointer font-heebo hover:bg-[#b9c7ff] hover:bg-opacity-40'
            >
              <input
                type='checkbox'
                checked={selectedItems.includes(item)}
                onChange={() => onToggleItem(item)}
                className='h-4 w-4 cursor-pointer accent-[#3C5BD2]'
              />
              {item}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default ItemComboBox;
